import React, { useContext } from 'react';
import styled from 'styled-components';
import KpiSlideOutContext from '../contexts/KpiSlideOutContext';
import Row from 'components/Common/Row';
import Typography from 'kingpin/atoms/Typography';
import Button from 'kingpin/atoms/Button';

const TopBarSlideout = styled.div`
  box-shadow: var(--shadow-inset);
  margin-bottom: 8px;
  padding: 16px 24px;
`;

const SlideoutHeader = ({ name }: { name: string }) => {
  const { close } = useContext(KpiSlideOutContext);

  return (
    <TopBarSlideout>
      <Row centerAlign spaceBetween style={{ height: '100%' }}>
        <Row centerAlign style={{ height: '100%' }}>
          <Typography.Header type="H4">{name}</Typography.Header>
        </Row>
        <Button type="Secondary" size="Small" onClick={close} icon="cross" />
      </Row>
    </TopBarSlideout>
  );
};

export default SlideoutHeader;
